// src/components/common/RatingDisplay.jsx
import { Star } from 'lucide-react';
import PropTypes from 'prop-types';

const RatingDisplay = ({ 
  rating = 0, 
  size = 'md',      // 'sm', 'md', 'lg'
  showNumber = true,
  className = ''
}) => {
  const maxStars = 5;
  const filledStars = Math.floor(rating);
  const hasHalf = rating % 1 >= 0.5;

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-7 h-7'
  };

  const textClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-xl'
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {[...Array(maxStars)].map((_, i) => {
        if (i < filledStars) {
          return <Star key={i} className={`fill-yellow-400 text-yellow-400 ${sizeClasses[size]}`} />;
        }
        if (i === filledStars && hasHalf) {
          return (
            <div key={i} className="relative">
              <Star className={`text-gray-300 ${sizeClasses[size]}`} />
              <div className="absolute inset-0 overflow-hidden" style={{ width: '50%' }}>
                <Star className={`fill-yellow-400 text-yellow-400 ${sizeClasses[size]}`} />
              </div>
            </div>
          );
        }
        return <Star key={i} className={`text-gray-300 ${sizeClasses[size]}`} />;
      })}

      {showNumber && (
        <span className={`font-semibold text-gray-700 ${textClasses[size]} ml-2`}>
          {rating}
        </span>
      )}
    </div>
  );
};


RatingDisplay.propTypes = {
  rating: PropTypes.number,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  showNumber: PropTypes.bool,
  className: PropTypes.string
};

export default RatingDisplay;